module.exports = __webpack_public_path__ + "img/IMG_3346_2028_P_T_L_Wood_MockedUp.33bc1e4c.jpg";